import React, { useEffect, useState } from "react";
import Heading from "../../components/Heading";
import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import ComplinceIcon from "../../styles/img/CompliNYC-Logo.png";
import Table from "./components/table/Table";
import Filters from "./components/filters";
import DownloadAuditReport from "../Client/detail/components/Units/DownloadAuditReport";
import EnterSurveyResponse from "./components/SurveyResponse";
import { downloadLl55AuditReport } from "../../sevices/ll55Api";
import { useLL55Compliance } from "../../reactQuery/ll55";
import { isAdmin, isSelfService } from "../../utils/helpers";

function LL55() {
  const [year, setYear] = useCustomSearchParams("year");
  const currentYear = new Date().getFullYear();
  const [building_id] = useCustomSearchParams("building");
  const [client] = useCustomSearchParams("client");
  const [isChangeRefetch] = useCustomSearchParams("refetch");
  const [isPastYear, setPastYear] = useState(false);
  

   const {
     totalRecords,
     refetch
   } = useLL55Compliance(`?page=1&page_size=100${year ? `&year=${year}` : ""}`);

  useEffect(() => {
    setPastYear(currentYear > year);
  }, [year]);

  useEffect(() => {
    setYear("year", year || currentYear);
  }, []);

  useEffect(() => {
    refetch();
  }, [year, isChangeRefetch]);

  return (
    <div>
      <Heading title="LL55 - Allergen">
        {isPastYear ||
          ((isAdmin() || isSelfService()) && <EnterSurveyResponse />)}
        {(isAdmin() || isSelfService()) && (
          <DownloadAuditReport
            building={building_id}
            client={client}
            downloadAuditReportPdf={downloadLl55AuditReport}
            reportId={"mailerPdfId"}
            type="ll55"
          />
        )}
      </Heading>

      <div className="mt-4 ticket-page ">
        <Filters
          building={building_id}
          client={client}
          isFilterHide={currentYear < year && totalRecords == 0}
        />
        {currentYear < year && totalRecords == 0 ? (
          <div className="new-year-blank-compliance">
            <img src={ComplinceIcon} />
          </div>
        ) : (
          <Table />
        )}
      </div>
    </div>
  );
}

export default LL55;
